import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import { parseHtmlForReact } from '../../helpers'

 @observer
class PriorityWell extends PureComponent {
    getText = () => {
        const { question, option, store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        let text = ''
        if (option.langs[langcode]) {
            ({ text } = option.langs[langcode])
        } else if (option.langs[defaultLocale]) {
            ({ text } = option.langs[defaultLocale])
        } else if (option.langs[initialLocale]) {
            ({ text } = option.langs[initialLocale])
        }

        // return option.langs[langcode]
        //     ? option.langs[langcode].text
        //     : option.langs[defaultLocale]
        //         ? option.langs[defaultLocale].text : ''
        return text
    }

    render() {
        const {
            option, question, store, displayMobile, disabled, answered, handleClick,
        } = this.props
        const { form_data, is_rtl_language } = store
        const currValue = form_data.has(question.id) && form_data.get(question.id).data.hasOwnProperty(option.id) ? form_data.get(question.id).data[option.id] : ''
        console.log(`optionwell ${option.id} ${answered}`)
        let psClass = 'question__priority__option radius'
        psClass += answered ? ' selected' : ''
        psClass += disabled ? ' disabled' : ''
        return (
            <div
                className={psClass}
                onClick={() => handleClick(option)}
            >
                {parseHtmlForReact(store.getOptionTitle(option, question))}
                {displayMobile && currValue
                    && <span className="mobilePriority">{currValue}</span>
                }
            </div>
        )
    }
 }

export default PriorityWell
